import { render, staticRenderFns } from "./DraftEmailMessageListItem.vue?vue&type=template&id=f5be2c8a"
import script from "./DraftEmailMessageListItem.vue?vue&type=script&lang=js"
export * from "./DraftEmailMessageListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports